import React from "react";
import Partners from "../../Components/home/Partners/Partners";
import News from "../../Components/home/News/News";
import Services from "../../Components/home/Services/Services";
import Solutions from "../../Components/home/Solutions/Solutions";
import Setem from "../../Components/home/Setem/Setem";
import WhyUsHome from "../../Components/home/WhyUs/WhyUsHome";
import Hero from "../../Components/home/Hero/Hero";

const Home = () => {

  return (
    <div>
      <div>
        <Hero/>
        <WhyUsHome />
        <Services />
        <News />
        <Setem />
        <Partners />
        <Solutions />
      </div>
    </div>
  );
};

export default Home;
